<style>
  tr:hover td {
      background-color: #3F51B5;
  }
    .zeroTokens {color: #E91E63 !important;}
    .lowTokens {color: #e9d81e !important;}
    .okTokens {color: #0f9e3e !important;}

</style>
<template>
  <div>
	<h1 class="page-header mb-3">Chat App Users</h1>
  <div class="row">
      <div class="col-xl-12">
        <div class="card border-0 mb-3 overflow-hidden bg-gray-800 text-white">
          <div class="card-body">
            <div v-if="loading" class="loading text-center"><div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div></div>

            <div v-if="error" class="alert alert-danger">
              {{ error }}
            </div>

            <p v-if="rows && rows.length">
              <b style="color: white;">{{ rows.length }}</b> users shown<span v-if="total > rows.length"> of <b style="color: white;">{{ total }}</b> total</span>
              &nbsp;&mdash;&nbsp;
              <b class="zeroTokens">{{ zeroTokenCount() }}</b> at zero tokens.
            </p>

            <vue-good-table
              :columns="columns"
              v-if="rows && rows.length"
                :rows="rows"
              :lineNumbers="false"
              :search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Search Current Table' }"
              :pagination-options="{ enabled: true,  position: 'bottom', perPage: 20, mode: 'pages' }"
              :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: true,
                selectionInfoClass: 'alert alert-info m-b-0 no-rounded-corner',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
              :sort-options="{
                enabled: true,
                multipleColumns: true,
                initialSortBy: [{field: 'lastActivityAt', type: 'desc'}]
              }"
            >
              <div slot="table-actions">
                <button class="btn btn-primary ms-2 fw-bold" @click="fetchData">REFRESH <span class="fa fa-refresh"></span></button>
              </div>
              <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'actions'">
                    <button class="btn btn-sm btn-outline-info" @click.stop="openGrantModal(props.row)">Add Tokens</button>
                  </span>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
              </template>
            </vue-good-table>

            <div v-if="!loading && !error && rows && !rows.length" class="alert alert-warning">
              No chat users found.
            </div>
          </div>
        </div>
      </div>
    </div>

<b-modal id="grant-modal" size="md" cancel-variant="default" no-close-on-backdrop>
  <template slot="modal-header">
    <h4 class="modal-title">Add Tokens</h4>
    <a class="btn-close" @click="$bvModal.hide('grant-modal')"></a>
  </template>
  <div v-if="grantUser">
    <p class="text-center">
      User: <b style="color: white;">{{grantUser.username}}</b> - Email: <b>{{grantUser.email}}</b> - Current Balance: <b style="color: white;">{{grantUser.balance}}</b>
    </p>
    <form>
      <div class="row mb-15px">
        <label class="form-label col-form-label col-md-4 text-end">Tokens to Add</label>
        <div class="col-md-4">
          <input type="number" min="1" max="100" class="form-control mb-5px" v-model.number="grantAmount" />
        </div>
      </div>
      <div class="row mb-15px">
        <label class="form-label col-form-label col-md-4 text-end">Note</label>
        <div class="col-md-8">
          <input type="text" class="form-control mb-5px" placeholder="Optional - why these tokens were added" v-model="grantNote" />
        </div>
      </div>
    </form>
  </div>
  <template #modal-footer="{ cancel }">
    <b-button variant="primary" :disabled="granting" @click="grantTokens();">
      <span v-if="granting" class="spinner-border spinner-border-sm" role="status"></span>
      <span v-else>ADD TOKENS <span class="fa fa-plus"></span></span>
    </b-button>&nbsp;
    <b-button variant="primary" :disabled="granting" @click="cancel()">
      CANCEL <span class="fa fa-cancel"></span>
    </b-button>
  </template>
</b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { useCookies } from "vue3-cookies";
import ChatApi from '../config/ChatApi.vue';


export default {
  name: 'chatusers',
    setup() {
      const { cookies } = useCookies();
      return { cookies };
    },
    data()
    {
      return {
        loading: false,
        error: null,
        total: 0,
        grantUser: null,
        grantAmount: 10,
        grantNote: '',
        granting: false,
        columns: [
          {
            label: 'Username',
            field: 'username',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'Email',
            field: 'email',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'Name',
            field: 'fullName',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'Tokens',
            field: 'balance',
            type: 'number',
            thClass: 'text-nowrap',
            tdClass: this.getTokenColor,
          },
          {
            label: 'Purchased',
            field: 'purchased',
            type: 'number',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'Used',
            field: 'used',
            type: 'number',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'Questions',
            field: 'questions',
            type: 'number',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'Conversations',
            field: 'conversations',
            type: 'number',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap'
          },
          {
            label: 'Joined',
            field: 'createdAt',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
            formatFn: this.formatJoined,
          },
          {
            label: 'Last Active',
            field: 'lastActivityAt',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
            formatFn: this.formatLastActive,
          },
          {
            label: 'Actions',
            field: 'actions',
            thClass: 'text-nowrap',
            tdClass: 'text-nowrap',
            sortable: false,
          }
        ],
        rows: null,
      }
    },
    methods: {
      fetchData()
      {
        this.error = null;
        this.loading = true;

        axios
          .get(ChatApi.base + '/api/admin/users', {
            headers: { 'x-admin-key': ChatApi.key },
            params: { limit: 500 }
          })
          .then(response => {
              let users = response.data.users || [];
              users.forEach(function (user) {
                user.fullName = ((user.firstName || '') + ' ' + (user.lastName || '')).trim();
              });
              this.rows = users;
              this.total = response.data.total || users.length;
              this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            this.error = 'Error loading chat users. Check the admin key in src/config/ChatApi.vue, then try again.';
            console.log(error);
          });
      },
      openGrantModal(row)
      {
        this.grantUser = row;
        this.grantAmount = 10;
        this.grantNote = '';
        this.granting = false;
        this.$bvModal.show('grant-modal');
      },
      grantTokens()
      {
        // No idempotency key on the endpoint - a second click would grant a second time.
        if (this.granting || !this.grantUser) return;

        let amount = parseInt(this.grantAmount, 10);
        if (isNaN(amount) || amount < 1 || amount > 100) {
          this.$swal.fire('Error', 'Enter a number of tokens between 1 and 100.', 'error');
          return;
        }

        let row = this.grantUser;
        this.granting = true;

        axios
          .post(ChatApi.base + '/api/admin/grant-tokens', {
            userId: row.id,
            amount: amount,
            note: this.grantNote
          }, {
            headers: { 'x-admin-key': ChatApi.key }
          })
          .then(response => {
            this.granting = false;
            // Update just this row - no refetch of the whole list.
            let balance = response.data && typeof response.data.balance !== 'undefined' ? response.data.balance : row.balance + amount;
            this.$set(row, 'balance', balance);
            this.$bvModal.hide('grant-modal');
            this.$swal.fire('Tokens added', amount + ' tokens added to ' + row.username + '. New balance: ' + balance + '.', 'success');
          })
          .catch(error => {
            this.granting = false;
            let message = error.response && error.response.data && error.response.data.message ? error.response.data.message : 'There was an error adding tokens. Please hit F12 and copy/paste the error message in the console and email support.';
            this.$swal.fire('Error', message, 'error');
            console.log(error);
          });
      },
      zeroTokenCount()
      {
        if (!this.rows) return 0;
        return this.rows.filter(function (row) {
          return !row.balance || row.balance <= 0;
        }).length;
      },
      getTokenColor(rowObj)
      {
        let balance = rowObj.balance || 0;
        if (balance <= 0) return 'text-nowrap zeroTokens';
        if (balance <= 2) return 'text-nowrap lowTokens';
        return 'text-nowrap okTokens';
      },
      formatJoined(value)
      {
        if (!value) return '-';
        return moment(value).format('MMM D, YYYY');
      },
      formatLastActive(value)
      {
        if (!value) return '-';
        return moment(value).format('MMM D, YYYY h:mm a');
      }
    },
    created() {
      // fetchData() is called by the auth guard in mounted().
    },
    mounted: function()
    {
      let username = this.cookies.get('username');
      let authenticated = this.cookies.get("authenticated");
      if (username === null || authenticated === null)
      {
        this.$router.push('/user/login-v3');
      }
      else {
        const crypto = require('crypto');
        const secret = 'GASEWkjshga@asdjfhasdfAA!fcaf@gdh#asdA';
        const hash = crypto.createHmac('sha256', secret)
            .update(authenticated)
            .digest('hex');
        if (username !== 'admin' || hash !== 'b8d32bd79ea384bb101f69e0935ee9c87be516c6642e39a479bf417b16354b2e') {
          this.$router.push('/user/login-v3');
        } else {
          this.fetchData();
        }
      }
    }
	}
</script>
